import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";

import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getPermissions as onGetPermissions,
    getActions as onGetActions,
    getFeatures as onGetFeatures,
    addNewPermission as onAddNewPermission,
    updatePermission as onUpdatePermission,
    deletePermission as onDeletePermission,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const ACTIONS = [
    {value: "create", label: "Créer"},
    {value: "read", label: "Lecture"}, 
    {value: "update", label: "Modifier"}, 
    {value: "delete", label: "Supprimer"},
]

const Permission = () => {

    //meta title
    document.title = "Permissions | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [permission, setPermission] = useState(null);
    const [selectedPermissionItems, setSelectedPermissionItems] = useState([]);
    
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: (permission && permission.uid) || '',
            //role_id: (permission && permission.role_id) || '',
            feature_id: (permission && permission.feature_id) || '',
            permission_items: (permission && permission.permission_items) || [],
            
        },
        validationSchema: Yup.object({
           
            //name: Yup.string().required("Veuillez saisir le nom"),
            //role_id: Yup.number().required("Veuillez sélectionner le role"),
            feature_id: Yup.number().required("Veuillez sélectionner la fonctionnalité"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updatePermission = {
                    //id: values.id,
                    uid: values.uid,
                    //role_id: values.role_id,
                    feature_id: values.feature_id,
                    permission_items: selectedPermissionItems,
                    
                };
                // update movie category
                dispatch(onUpdatePermission(updatePermission));
                validation.resetForm();
            } else {
                const newPermission = {
                    //id: values["id"],
                    //uid: values["uid"],
                    //role_id: values["role_id"],
                    feature_id: values["feature_id"],
                    permission_items: selectedPermissionItems,
                   
                };
                // save new permission

                console.log("BEFORE NEW ACTION CALL: ", newPermission);
                dispatch(onAddNewPermission(newPermission));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const PermissionProperties = createSelector(
        (state) => state.permissionReducer, // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
        (permissionReducer) => ({
            permissions: permissionReducer.permissions,
            loading: permissionReducer.loading
        })
    );

    const {permissions, loading} = useSelector(PermissionProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {
        if (permissions && !permissions.length) {
            dispatch(onGetPermissions());
        }
    }, [dispatch, permissions]);


     // Get roles
    // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
    const ActionProperties = createSelector(
        (state) => state.actionReducer, 
        (actionReducer) => ({
            actions: actionReducer.actions,
            loading: actionReducer.loading
        })
    );

    const {actions} = useSelector(ActionProperties);

    
        

    //const [isLoading, setLoading] = useState(loading)

    useEffect(() => {
        if (actions && !actions.length) {
            dispatch(onGetActions());
        }
    }, [dispatch, actions]);



    // Get features
    const FeatureProperties = createSelector(
        (state) => state.featureReducer, 
        (featureReducer) => ({
            features: featureReducer.features,
            loading: featureReducer.loading
        })
    );

    const {features} = useSelector(FeatureProperties);
    
    
    //const [isLoading, setLoading] = useState(loading)

    useEffect(() => {
        if (features && !features.length) {
            dispatch(onGetFeatures());
        }
    }, [dispatch, features]);



    const toggle = () => {
        if (modal) {
            setModal(false);
            setPermission(null);
        } else {
            setModal(true);
        }
    };

    const handlePermissionClick = arg => {
        const permission = arg;
        setPermission({
            //id: serialMovieCategory.id,
            uid: permission.uid,
            role_id: permission.role_id,
            feature_id: permission.feature_id,
            permission_items: permission.permission_items,
           
        });


        console.log("ON EDIT PERMISSION ITEMS:", permission.permission_items);
        setSelectedPermissionItems(permission.permission_items.map((item) =>  (item.action_name)));
        //setSelectedMovieCategories(movie.movie_categories.map((item) =>  (item.id)));


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (permission) => {
        setPermission(permission);
        setDeleteModal(true);
    };

    const handleDeletePermission = () => {
        if (permission && permission.id) {
            //dispatch(onDeleteSerialMovieCategory(serialMovieCategory.id));
            dispatch(onDeletePermission(permission.uid));
            setDeleteModal(false);
        }
    };

    const onClickNewPermission = () => {
        setIsEdit(false);
        setPermission(null);
        setSelectedPermissionItems([]);
        toggle();
        //setModal(true)
    };

     // On select change
    const handlePermissionItemChange = (selectedPermissionItem) => {
        setSelectedPermissionItems( selectedPermissionItem ? selectedPermissionItem.map((s) => s.value) : []);
    }

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Fonctionnalité",
                accessorKey: "feature.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
           
            
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            {/*
                            <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                                <Link to="/job-details" className="btn btn-sm btn-soft-primary" id={`viewtooltip-${cellProps.row.original.id}`}>
                                    <i className="mdi mdi-eye-outline" />
                                </Link>
                            </li>
                            
                            <UncontrolledTooltip placement="top" target={`viewtooltip-${cellProps.row.original.id}`}>
                                View
                            </UncontrolledTooltip>
                            */}

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handlePermissionClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeletePermission}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Permissions" breadcrumbItem="Liste des permissions" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewPermission} className="btn btn-primary me-1">Ajouter une permission</Link>
                                                    {/*<Link to="#!" className="btn btn-light me-1"><i className="mdi mdi-refresh"></i></Link>
                                                    <UncontrolledDropdown className="dropdown d-inline-block me-1">
                                                        <DropdownToggle type="menu" className="btn btn-success" id="dropdownMenuButton1">
                                                            <i className="mdi mdi-dots-vertical"></i></DropdownToggle>
                                                        <DropdownMenu>
                                                            <li><DropdownItem href="#">Action</DropdownItem></li>
                                                            <li><DropdownItem href="#">Another action</DropdownItem></li>
                                                            <li><DropdownItem href="#">Something else here</DropdownItem></li>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>*/}
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={permissions || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Permission" : "Ajouter - Permission"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                        
                                        

                                        <div className="mb-3">
                                            <Label>Fonctionnalité</Label>
                                            <Input
                                                name="feature_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.feature_id || ""
                                                }
                                                invalid={
                                                    validation.touched.feature_id && validation.errors.feature_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {features.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.feature_id && validation.errors.feature_id ? (
                                                <FormFeedback type="invalid">{validation.errors.feature_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Actions</Label>
                                            <Select
                                                isMulti
                                                name="permission_items"
                                                options={ACTIONS}
                                                value={ACTIONS.filter((option) => selectedPermissionItems.includes(option.value))}
                                                onChange={handlePermissionItemChange}
                                                menuPortalTarget={document.body}
                                                styles={{menuPortal: (base) => ({ ...base, zIndex: 9999 })}}

                                                invalid={
                                                    validation.touched.permission_items && validation.errors.permission_items
                                                        ? true
                                                        : false
                                                }
                                                
                                               
                                            />

                                            {validation.touched.permission_items && validation.errors.permission_items ? (
                                                <FormFeedback type="invalid">{validation.errors.permission_items}</FormFeedback>
                                            ) : null}
                                            
                                        </div>
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default Permission;